/** Which cost template each agent signs (none = MSC default costs) and whether their payout costs are live. */
import React, { useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { btnSmall, errorText } from '../finance/financeUi';

const LABEL = { ACTIVE: 'live', WAITING_PROCESSOR_COSTS: 'waiting for processor costs', PENDING_APPROVAL: 'waiting for approval', NO_PROCESSOR_SCHEDULE: 'no processor schedule', NO_COSTS: 'no payout costs', ERROR: 'error' };

function PayoutStatus({ sync }) {
  if (!sync) return <span className="text-xs text-muted-foreground">Set up when the agent signs</span>;
  return <span className="text-xs" title={(sync.results || []).map((r) => `${r.provider_slug}: ${LABEL[r.status] || r.status}`).join('\n')}>{sync.active} live · {sync.waiting} waiting</span>;
}

export function TemplateAssignments({ agents, templates, onChanged }) {
  const [q, setQ] = useState('');
  const assign = async (a, templateId) => {
    try {
      await api.request(`/admin/schedule-a/agents/${a.user_id}/template`, { method: 'PUT', body: JSON.stringify({ template_id: templateId || null }) });
      toast.success(`${a.name} → ${templates.find((t) => t.template_id === templateId)?.name || 'MSC default costs'}. They'll sign the updated Schedule A.`);
      onChanged();
    } catch (e) { toast.error(errorText(e)); }
  };
  const sync = async (a) => {
    try { const r = await api.request(`/admin/schedule-a/agents/${a.user_id}/payout-sync`, { method: 'POST' }); toast.success(r.note || `${r.active} platform cost schedules live, ${r.waiting} waiting`); onChanged(); } catch (e) { toast.error(errorText(e)); }
  };
  const shown = agents.filter((a) => `${a.name} ${a.email}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="space-y-3 px-5 py-4" data-testid="template-assignments">
      <input className="h-9 w-full max-w-xs rounded-md border px-3 text-sm" placeholder="Search agents" value={q} onChange={(e) => setQ(e.target.value)} data-testid="assign-search" />
      <div className="overflow-x-auto"><table className="w-full min-w-[640px] text-sm">
        <thead><tr className="border-b text-left text-[11px] uppercase text-muted-foreground"><th className="py-2">Agent</th><th>Cost template</th><th>Payout costs</th><th /></tr></thead>
        <tbody>{shown.map((a) => (
          <tr key={a.user_id} className="border-b last:border-0" data-testid={`assign-row-${a.user_id}`}>
            <td className="py-2"><p className="font-medium">{a.name}</p><p className="text-xs text-muted-foreground">{a.email}</p></td>
            <td><select className="h-9 rounded-md border bg-background px-2 text-sm" value={a.template_id || ''} onChange={(e) => assign(a, e.target.value)} data-testid={`assign-select-${a.user_id}`}>
              <option value="">MSC default costs</option>{templates.map((t) => <option key={t.template_id} value={t.template_id}>{t.name}</option>)}</select></td>
            <td><PayoutStatus sync={a.payout_sync} /></td>
            <td className="text-right"><button type="button" className={btnSmall} onClick={() => sync(a)} data-testid={`assign-sync-${a.user_id}`}>Refresh payout costs</button></td>
          </tr>))}</tbody>
      </table></div>
    </div>
  );
}
